import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

import { TextTagStyle } from '~/atomic/Typography';

interface AbonnementProgressProps extends HTMLAttributes<HTMLDivElement> {
  progressRead: number;
  height: number;
  isShowText?: boolean;
}

export const AbonnementProgress = ({
  progressRead, height, isShowText = false, ...props
}: AbonnementProgressProps) => {
  return (
    <SCProgress
      {...props}
      data-text={isShowText ? `прочитано ${progressRead}%` : undefined}
      style={{
        ['--progress-percentage' as string]: `${progressRead}%`,
        height,
      }}
    />
  );
};

const SCProgress = styled.div`
  background: #D9D9D9;
  border-radius: 3px;
  width: 100%;
  max-width: 420px;
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: var(--progress-percentage);
    height: 100%;
    border-radius: 3px;
    background: #E9AD11;
    z-index: 1;
  }

  &:before {
    content: attr(data-text);
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${TextTagStyle};
    color: var(--black-color);
    z-index: 2;
  }
`;
